import * as Yup from 'yup'
import { parsePhoneNumberWithError } from 'libphonenumber-js'

export const signupFirstStepValidation = Yup.object({
  firstName: Yup.string().required('First name is required'),
  lastName: Yup.string().required('Last name is required'),
  gender: Yup.string().required('Gender is required'),
  birthYear: Yup.string().required('Birth year is required'),
  phone: Yup.string()
    .required('Valid mobile number is required')
    .test('is-valid-phone', 'Please input a valid mobile number', (value) => {
      if (!value) return false
      try {
        let parsed = value.startsWith('+')
          ? parsePhoneNumberWithError(value)
          : parsePhoneNumberWithError(value, 'SE')

        if (
          parsed.country === 'SE' &&
          (!parsed.number.startsWith('+467') ||
            parsed.nationalNumber.length !== 9)
        ) {
          return false
        }

        return parsed.isValid()
      } catch {
        return false
      }
    })
})

export const signupSecondStepValidation = Yup.object().shape({
  email: Yup.string().email('Invalid email').required('Email is required'),
  confirmEmail: Yup.string()
    .oneOf([Yup.ref('email'), null], 'Email and confirm email must match')
    .required('Please confirm your email'),

  password: Yup.string()
    .min(6, 'Password must be at least 8 characters')
    .required('Password is required'),

  confirmPassword: Yup.string()
    .oneOf(
      [Yup.ref('password'), null],
      'Password and confirm password must match'
    )
    .required('Please confirm your password'),

  privacyPolicyChecked: Yup.boolean().oneOf(
    [true],
    'You must accept the terms to continue'
  ),

  emailConsent: Yup.boolean()
})
